export default {
  appName: "CurlyScan",
  loading: "Loading...",
  error: "An error occurred",
  save: "Save",
  cancel: "Cancel",
  delete: "Delete",
  edit: "Edit",
  submit: "Submit",
  success: "Success",
  failed: "Failed",
  emailValidated: "Email Successfully Validated!",
  emailValidatedDescription: "Your email has been successfully validated. You can now access CurlyScan. You will be redirected to the login page in a few seconds.",
  goToLogin: "Go to Login",
  login: "Login",
  logout: "Logout",
  profile: "Profile",
  settings: "Settings",
  myReviews: "My Reviews"
};